// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';
import { Link } from '../../internal/Button';
import ResponsiveImage from '../../internal/ResponsiveImage';
import FormattedContent from '../../internal/FormattedContent';
import type { BlockRichText } from '../../internal/types';

const ctaVariantMap = {
  Low: 'Default',
  Medium: 'Default',
  High: 'Default',
  Dark: 'DefaultInverse',
};

const blockVariantMap = {
  Low: 'Featured',
  Medium: 'Default',
  High: 'DefaultContrast',
  Dark: 'Dark',
};

type PropTypes = {|
  background: 'Low' | 'Medium' | 'High' | 'Dark',

  image: string,
  alt?: string,
  position: 'Left' | 'Right',

  title?: string,
  children?: BlockRichText,

  ctaText?: string,
  ctaHref?: string,
|};

const CtaTextAndImage = (props: PropTypes) => {
  const classname = cx(styles.ctaTextAndImage, props.position === 'Left' && styles.isLeft);
  const cta = props.ctaText && props.ctaHref && (
    <Link href={props.ctaHref} variant={ctaVariantMap[props.background]}>
      {props.ctaText}
    </Link>
  );

  return (
    <PageContentBlock background={blockVariantMap[props.background]}>
      <div className={classname}>
        <ResponsiveImage
          className={styles.image}
          src={props.image}
          alt={props.alt}
          defaultSize={{ width: 700 }}
          srcSet={[
            { mediaMaxWidth: 1000, width: 500 },
            { mediaMaxWidth: 767, width: 767 },
            { mediaMaxWidth: 600, width: 600 },
            { mediaMaxWidth: 400, width: 400 },
          ]}
        />
        <div className={styles.contentContainer}>
          {props.title && <h2 className={styles.title}>{props.title}</h2>}
          {props.children && (
            <FormattedContent
              isDarkBackground={props.background === 'Dark'}
              className={styles.text}
            >
              {props.children}
            </FormattedContent>
          )}
          {cta}
        </div>
      </div>
    </PageContentBlock>
  );
};

CtaTextAndImage.defaultProps = {
  position: 'Left',
  background: 'Low',
};

export default CtaTextAndImage;
